import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const RelatedEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const { id } = useParams(); // /conference/details/:id se last id milegi

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch("https://eventscons.com/eventbackendnew/api/con");
        const result = await response.json();

        const eventList = Array.isArray(result)
          ? result
          : result.data || result.conferences || [];

        const filteredEvents = eventList
          .filter((item) => Number(item.id) !== Number(id))
          .map((item) => ({
            id: item.id,
            title: item.title,
            description: item.description,
            date: item.start_date,
            time: item.end_date,
            image: item.image
              ? `https://eventscons.com/eventbackendnew/storage/app/public/${item.image}`
              : "https://via.placeholder.com/400x250?text=No+Image",
          }));

        setEvents(filteredEvents);
      } catch (error) {
        console.error("Error fetching conferences:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, [id]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
    });
  };

  const formatTime = (startDate, endDate) => {
    if (!startDate || !endDate) return "Time not available";

    const start = new Date(startDate);
    const end = new Date(endDate);

    return `${start.toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })} - ${end.toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })}`;
  };

  if (loading) {
    return <div style={styles.loading}>Loading events...</div>;
  }

  return (
    <section style={styles.section}>
      <h2 style={styles.heading}>
        Our  <span style={styles.headingHighlight}>Events</span>
      </h2>

      <div style={styles.grid}>
        {events.slice(0, 3).map((event) => (
          <div key={event.id} style={styles.card}>
            <div style={styles.imageWrapper}>
              <a href={`${event.id}`}><img src={event.image} alt={event.title} style={styles.image} /></a>

              <div style={styles.badgeContainer}>
                <span style={styles.badge}>{formatDate(event.date)}</span>
                {/* <span style={styles.badge}>
                  {formatTime(event.date, event.time)}
                </span> */}
              </div>
            </div>

            <div style={styles.content}>
              <a href={`${event.id}`}><h3 style={styles.title}>{event.title}</h3></a>
              <p style={styles.description}>
                {event.description?.replace(/\r?\n/g, " ").length > 55
                  ? event.description.replace(/\r?\n/g, " ").slice(0, 55) + "..."
                  : event.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: "50px 20px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  heading: {
    textAlign: "center",
    fontSize: "32px",
    fontWeight: "700",
    marginBottom: "30px",
    color: "#111",
  },
  headingHighlight: {
    color: "#c43b3b",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "24px",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    overflow: "hidden",
  },
  imageWrapper: {
    position: "relative",
    width: "100%",
    height: "190px",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },
  badgeContainer: {
    position: "absolute",
    top: "10px",
    left: "10px",
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
  },
  badge: {
    backgroundColor: "#fff",
    color: "#222",
    fontSize: "11px",
    fontWeight: "600",
    padding: "5px 10px",
    borderRadius: "20px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
  },
  content: {
    padding: "14px 12px 16px",
  },
  title: {
    fontSize: "22px",
    fontWeight: "700",
    color: "#111",
    margin: "0 0 6px 0",
  },
  description: {
    fontSize: "14px",
    color: "#666",
    margin: 0,
    lineHeight: "1.5",
  },
  loading: {
    textAlign: "center",
    padding: "40px",
    fontSize: "18px",
  },
};

export default RelatedEvents;